import request from "@/utils/request";

export const categoryLeaderApi = {
    query: (queryCondition) => {
        return request({
            url: "/categoryLeader/query",
            method: "post",
            data: queryCondition,
        });
    },
    findCategory: (data) => {
        return request({
            url: "/category/findAllCategory",
            method: "post",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            data: data,
        });
    },
    save: (data) => {
        return request({
            url: "/categoryLeader/save",
            method: "post",
            data: data,
        });
    },
    saveAdd: (data) => {
        return request({
            url: "/categoryLeader/add",
            method: "post",
            data: data,
        });
    },
    del: () => {
        return request({
            url: "/repository/models",
            method: "delete",
            params: params,
        });
    },
    getDetail: (data) => {
        return request({
            url: "/categoryLeader/getDetail",
            method: "post",
            data: data,
        });
    },
};